const EpollParser = (formDto, answers) => {
  let questionAnswersObj = [];
  if (!formDto) {
    return questionAnswersObj;
  } else if (!Array.isArray(formDto.fields)) {
    return questionAnswersObj;
  }
  console.log(answers);
  formDto.fields.forEach((questionDto) => {
    // console.log(formDto.fields)
    const findAnswerId = (answer, question) => {
      let questionsOptions = questionDto.options;
      if (question) {
        questionsOptions = question.options;
      }
      if (Array.isArray(questionsOptions)) {
        let answer_id = null;

        questionsOptions.forEach((el) => {
          if (el.label) {
            // console.log(`${getLabel(el)}`.trim() , answer)
            if (
              `${getLabel(el)}`.trim().replace(/\s/g, "") ===
              `${answer}`.trim().replace(/\s/g, "")
            ) {
              answer_id = el.id;
            } else if (
              `${getPlainLabel(el.label)}` === `${getPlainLabel(answer)}`
            ) {
              console.log(el);
              answer_id = el.id;
            }
          }
        });
        return answer_id;
      }

      return null;
    };
    let questionIndex = questionDto.label
      .replace(/(<([^>]+)>)/gi, "")
      .replace(/&zwnj;/gi, "_")
      .replace(/&lrm;/gi, "_")
      .replace(/&laquo;/gi, " ")
      .replace(/&raquo;/gi, " ")
      .replace(/&nbsp;/gi, "_")
      .replace(/\s/gi, "_");
    if (questionDto.question_number) {
      questionIndex = questionDto.question_number;
    }

    if (questionDto.field_type === "text") {
      const answer = answers ? answers[questionIndex] : null;
      questionAnswersObj.push({
        id: questionDto.id,
        question: getLabel(questionDto),
        answer,
        answer_id: findAnswerId(answer),
      });
    } else if (questionDto.field_type === "multidropdown") {
      if (questionDto.question_number !== "") {
        let subQuestions = questionDto.questions;
        subQuestions.forEach((subQuestion, index) => {
          if (answers[questionIndex + "_" + (index + 1)]) {
            const answer = answers[questionIndex + "_" + (index + 1)];
            questionAnswersObj.push({
              id: subQuestion.id,
              question:
                questionDto.question_number +
                " " +
                getLabel(questionDto) +
                " => " +
                getLabel(subQuestion),
              answer: answer,
              answer_id: findAnswerId(answer, subQuestion),
            });
          }
        });
      } else {
        let subQuestions = questionDto.questions;
        subQuestions.forEach((subQuestion, index) => {
          if (answers[questionIndex + "_:__" + (index + 1)]) {
            const answer = answers[questionIndex + "_:__" + (index + 1)];
            questionAnswersObj.push({
              id: subQuestion.id,
              question:
                questionDto.question_number +
                " " +
                getLabel(questionDto) +
                " => " +
                getLabel(subQuestion),
              answer,
              answer_id: findAnswerId(answer, subQuestion),
            });
          }
        });
      }
    } else if (questionDto.field_type === "multitext") {
      let subQuestions = questionDto.options;
      subQuestions.forEach((subQuestion, index) => {
        if (answers[questionIndex + "_" + (index + 1)]) {
          const answer = answers[questionIndex + "_" + (index + 1)];
          questionAnswersObj.push({
            id: subQuestion.id,
            question: getLabel(questionDto) + " => " + getLabel(subQuestion),
            answer,
          });
        }
      });
    } else if (questionDto.field_type === "checkboxes") {
      let subQuestions = questionDto.options;
      subQuestions.forEach((subQuestion, index) => {
        if (answers[questionIndex + "_" + (index + 1)]) {
          if (answers[questionIndex + "_" + (index + 1) + "_Text"]) {
            const answer =
              answers[questionIndex + "_" + (index + 1)] +
              " => " +
              answers[questionIndex + "_" + (index + 1) + "_Text"];

            questionAnswersObj.push({
              id: questionDto.id,
              question: getLabel(questionDto),
              answer,
              answer_id: findAnswerId(
                answers[questionIndex + "_" + (index + 1)]
              ),
              field_type: "checkboxes",
            });
          } else {
            questionAnswersObj.push({
              id: questionDto.id,
              question: getLabel(questionDto),
              answer: answers[questionIndex + "_" + (index + 1)],
              answer_id: findAnswerId(
                answers[questionIndex + "_" + (index + 1)]
              ),
              field_type: "checkboxes",
            });
          }
        }
      });
    } else if (questionDto.field_type === "paragraph") {
      if (answers[questionIndex]) {
        const answer = answers[questionIndex];
        questionAnswersObj.push({
          id: questionDto.id,
          question: getLabel(questionDto),
          answer,
          answer_id: findAnswerId(answer),
        });
      }
    } else if (questionDto.field_type === "radio") {
      if (answers[questionIndex + "_Text"]) {
        const answer =
          answers[questionIndex] + " => " + answers[questionIndex + "_Text"];
        questionAnswersObj.push({
          id: questionDto.id,
          question: getLabel(questionDto),
          answer,
          answer_id: findAnswerId(answers[questionIndex]),
        });
      } else if (answers[questionIndex]) {
        const answer = answers[questionIndex];
        questionAnswersObj.push({
          id: questionDto.id,
          question: getLabel(questionDto),
          answer,
          answer_id: findAnswerId(answer),
        });
      }
    } else if (questionDto.field_type === "break") {
      questionAnswersObj.push({
        id: questionDto.id,
        type: "break",
        label: getLabel(questionDto),
      });
    } else if (questionDto.field_type === "number") {
      if (answers[questionIndex]) {
        const answer = answers[questionIndex];
        questionAnswersObj.push({
          id: questionDto.id,
          question: getLabel(questionDto),
          answer,
          answer_id: findAnswerId(answer),
        });
      }
    } else if (questionDto.field_type === "mobile") {
    } else if (questionDto.field_type === "html") {
    } else if (questionDto.field_type === "dropdown") {
      const answer = answers ? answers[questionIndex] : null;
      questionAnswersObj.push({
        id: questionDto.id,
        question: getLabel(questionDto),
        answer,
        answer_id: findAnswerId(answer),
      });
    } else if (questionDto.field_type === "matrix") {
      if (questionDto.question_number !== "") {
        let subQuestions = questionDto.questions;
        subQuestions.forEach((subQuestion, index) => {
          let options = subQuestion.options;
          options.forEach((option, optionIndex) => {
            if (
              answers[
                questionIndex + "_" + (index + 1) + "_" + (optionIndex + 1)
              ]
            ) {
              const answer =
                answers[
                  questionIndex + "_" + (index + 1) + "_" + (optionIndex + 1)
                ];
              questionAnswersObj.push({
                id: subQuestion.id,
                question:
                  getLabel(questionDto) + " => " + getLabel(subQuestion),
                answer: answer,
                answer_id: findAnswerId(answer, subQuestion),
              });
            }
          });
        });
      }
    } else if (questionDto.field_type === "matrixpriority") {
      if (questionDto.question_number !== "") {
        let subQuestions = questionDto.questions;
        subQuestions.forEach((subQuestion, index) => {
          if (answers[questionIndex + "_" + (index + 1)]) {
            const answer = answers[questionIndex + "_" + (index + 1)];
            questionAnswersObj.push({
              id: subQuestion.id,
              question: getLabel(questionDto) + " => " + getLabel(subQuestion),
              answer: answer,
              answer_id: findAnswerId(answer, subQuestion),
            });
          }
        });
      }
    } else if (questionDto.field_type === "nps") {
      if (answers[questionIndex]) {
        const answer = answers[questionIndex];
        questionAnswersObj.push({
          id: questionDto.id,
          question: getLabel(questionDto),
          answer,
          answer_id: findAnswerId(answer),
        });
      }
    } else if (questionDto.field_type === "rating") {
      if (questionDto.question_number !== "") {
        let subQuestions = questionDto.questions;
        subQuestions.forEach((subQuestion, index) => {
          console.log(answers[questionIndex + "_" + (index + 1)]);
          if (answers[questionIndex + "_" + (index + 1)]) {
            const answer = answers[questionIndex + "_" + (index + 1)];
            questionAnswersObj.push({
              id: subQuestion.id,
              question: getLabel(questionDto) + " => " + getLabel(subQuestion),
              answer: answer,
              answer_id: findAnswerId(answer, subQuestion),
            });
          }
        });
      }
    } else if (questionDto.field_type === "date") {
      const answer = answers ? answers[questionIndex] : null;
      questionAnswersObj.push({
        id: questionDto.id,
        question: getLabel(questionDto),
        answer,
      });
    } else if (questionDto.field_type === "city") {
      questionAnswersObj.push({
        id: questionDto.id + "_State_/_Province",
        question: questionDto.question_number + ": " + "استان",
        answer: answers[questionIndex + "_State_/_Province"],
      });
      questionAnswersObj.push({
        id: questionDto.id + "_City",
        question: questionDto.question_number + ": " + "شهرستان",
        answer: answers[questionIndex + "_City"],
      });
    } else {
      alert("unknown question type: " + questionDto.field_type);
      console.error("unknown", questionDto.field_type);
    }
  });
  // console.log(questionAnswersObj)
  return questionAnswersObj;
};
export const getLabel = (question) => {
  return (
    (question.question_number ? question.question_number + ": " : "") +
    question.label
      .replace(/(<([^>]+)>)/gi, " ")
      .replace(/&zwnj;/gi, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/&laquo;/gi, " ")
      .replace(/&raquo;/gi, " ")
      .replace(/&lrm;/gi, "‎")
  );
};
export const getPlainLabel = (label) => {
  return (
    (label ?? "")
      ?.replace(/(<([^>]+)>)/gi, " ")
      ?.replace(/&zwnj;/gi, " ")
      ?.replace(/&nbsp;/gi, " ")
      ?.replace(/&laquo;/gi, " ")
      ?.replace(/&raquo;/gi, " ")
      ?.replace(/&lrm;/gi, "‎")
      ?.trim() ?? ""
  );
};

export default EpollParser;
